<template>
    <div>
        <div class="header">
            <slot name="header">
                <h4 class="title">{{title}}</h4>
                <p class="category">{{subTitle}}</p>
            </slot>
        </div>
        <div class="content table-responsive table-full-width" id="table">
            <table class="table" :class="tableClass">
                <thead>
                <th class="text-center" v-for="name in columnsNames" v-if="checkAmountPermission(name)">
                    {{name}}
                </th>
                </thead>
                <tbody class="text-center">
                <tr v-for="item in data">
                    <td v-for="column in columns" :class="{ 'text-right': column == 'amount' }"
                        v-if="hasValue(item, column) && checkAmountPermission(column)">{{ column == 'amount' ?
                        numberFormatter(itemValue(item,column)) :
                        numberFormatterThousand(itemValue(item, column))}}
                    </td>
                </tr>
                <tr>
                    <td>Suma</td>
                    <td>{{sum.download | thousandSep }}</td>
                    <td>{{sum.first | thousandSep }}</td>
                    <td>{{sum.strong | thousandSep }}</td>
                    <td>{{sum.fills | thousandSep }}</td>
                    <td :class="{'bigAmountSize' : sum.amount > 1000000}" class="text-right" v-if="!getPermission('hideAmounts')">{{sum.amount | filter }}</td>
                </tr>
                </tbody>

            </table>
        </div>
    </div>
</template>
<script>

  export default {
    data () {
      return {}
    },
    created () {
    },

    props: {
      sum: Object,
      columns: Array,
      data: Array,
      type: {
        type: String, // striped | hover
        default: 'striped'
      },
      title: {
        type: String,
        default: ''
      },
      subTitle: {
        type: String,
        default: ''
      },
      columnsNames: Array
    },
    watch: {
      data () {}
    },
    computed: {
      tableClass () {
        return `table-${this.type}`
      }
    },
    methods: {
      hasValue (item, column) {
        return item[column.toLowerCase()] !== 'undefined'
      },
      itemValue (item, column) {
        return item[column.toLowerCase()]
      },
      checkAmountPermission (columnName) {
        return !((columnName === 'Kwota' || columnName === 'amount') && this.getPermission('hideAmounts'))
      }
    }
  }
</script>
<style>
    #table > .table-striped > tbody > tr > td {
        padding: 3px;
    }
    .bigAmountSize{
        font-size: 0.88em;
    }
</style>



// WEBPACK FOOTER //
// DownloadTable.vue?7e07ffbc